const globalHasOwnProperty = Object.prototype.hasOwnProperty;
/**
 * protection against hasOwnProperty overrides.
 */
export function hasOwnProperty(obj, key) {
    return globalHasOwnProperty.call(obj, key);
}
export function hasKey(obj, key) {
    return key in obj;
}
